import { graphql, fetchQuery } from 'react-relay';
import type { Environment } from 'relay-runtime';

const fetchChargeQuery = async (
  environment: Environment,
  correlationID: string,
) => {
  await fetchQuery(
    environment,
    graphql`
      query fetchChargeQuery($correlationID: String) {
        # eslint-disable-next-line relay/must-colocate-fragment-spreads
        ...Order_query
        charge(correlationID: $correlationID) {
          status
          redirectUrl
          # eslint-disable-next-line relay/must-colocate-fragment-spreads
          ...Order_charge
        }
      }
    `,
    {
      correlationID: correlationID?.toString(),
    },
  ).toPromise();
};

export default fetchChargeQuery;
